import { render, staticRenderFns } from "./material-rack-item.vue?vue&type=template&id=52c22a31&scoped=true"
import script from "./material-rack-item.vue?vue&type=script&lang=js"
export * from "./material-rack-item.vue?vue&type=script&lang=js"
import style0 from "./material-rack-item.vue?vue&type=style&index=0&id=52c22a31&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c22a31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c22a31')) {
      api.createRecord('52c22a31', component.options)
    } else {
      api.reload('52c22a31', component.options)
    }
    module.hot.accept("./material-rack-item.vue?vue&type=template&id=52c22a31&scoped=true", function () {
      api.rerender('52c22a31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/store-manage/material-rack-item.vue"
export default component.exports